
//#region [red] Constants

export const constants = {
  ADD: 'TASKS_ADD',
  CLEAR: 'TASKS_CLEAR',
  REMOVE: 'TASKS_REMOVE',
  SET: 'TASKS_SET',
  SELECT: 'TASKS_SELECT',
  UPDATE: 'TASKS_UPDATE',
  UPDATE_PROCESS: 'TASKS_UPDATE_PROCESS',
  UPDATE_PROCESS_LIST: 'TASKS_UPDATE_PROCESS_LIST',
  UPDATE_STARTDATE: 'TASKS_UPDATE_STARTDATE',
  UPDATE_STATUS: 'TASKS_UPDATE_STATUS',
  UPDATE_VIEW: 'TASKS_UPDATE_VIEW'
}

//#endregion

//#region [purple] Actions

export const actions = {
  add,
  clear,
  remove,
  set,
  select,
  update,
  updateProcess,
  updateProcessList,
  updateStartDate,
  updateStatus,
  updateView
};

function add({id, task}) {
  // { id: {task} }
  // { 'task1': {process: 'test', ...}}
  return { type: constants.ADD, task:{[id]: task} };
}

function clear() {
  return { type: constants.CLEAR };
}

function remove(id) {
  return { type: constants.REMOVE, id };
}

function set(tasks) {
  return { type: constants.SET, tasks };
}

function select(id) {
  return { type: constants.SELECT, id };
}

function update({id, task}) {
  return { type: constants.UPDATE, task:{[id]: task} };
}

function updateProcess(process) {
  return { type: constants.UPDATE_PROCESS, process };
}

function updateProcessList(process_list) {
  return { type: constants.UPDATE_PROCESS_LIST, process_list };
}

function updateStartDate(startdate) {
  return { type: constants.UPDATE_STARTDATE, startdate };
}

function updateStatus({id, status}) {
  return { type: constants.UPDATE_STATUS, id, status };
}

function updateView({id, view}) {
  return { type: constants.UPDATE_VIEW, id, view };
}


//#endregion

//#region [blue] Reducer

const initialState = {
  items: {},
  process: '',
  startdate: '',
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case constants.ADD: {
      return {
        ...state,
        items: {...state.items,...action.task},
      };
    };
    case constants.CLEAR: {
      return initialState;
    };
    case constants.REMOVE: {
      if( !state.items[action.id] ) return state;

      let {[action.id]: {}, ...newItems} = state.items;

      return {
        ...state,
        items: newItems
      }
    };
    case constants.SET: {
      return {
        ...state,
        items: action.tasks,
      };
    };
    case constants.SELECT: {
      if( !state.items.hasOwnProperty(action.id) ) return state;
      // if the same image is already selected then change nothing
      if( state.items[action.id].isSelected ) return state;

      let newState = {...state};
      const ids = Object.keys(newState.items);
      for( let id of ids ) {
        if( id === action.id ) newState.items[id].isSelected = true;
        else if(newState.items[id].isSelected ) newState.items[id].isSelected = false;
      }

      return newState;
    };
    case constants.UPDATE: {
      return {
        ...state,
        items: {...state.items, ...action.task},
      };
    };
    case constants.UPDATE_PROCESS: {
      let newState = {...state};
      newState.process = action.process;

      return newState;
    };
    case constants.UPDATE_PROCESS_LIST: {
      let newState = {...state};
      newState.process_list = action.process_list;

      return newState;
    };
    case constants.UPDATE_STARTDATE: {
      let newState = {...state};
      newState.startdate = action.startdate;

      return newState;
    };
    case constants.UPDATE_STATUS: {
      if( !state.items.hasOwnProperty(action.id) ) return state;

      let newState = {...state};
      newState.items[action.id].status = action.status;

      return newState;
    };
    case constants.UPDATE_VIEW: {
      if( !state.items.hasOwnProperty(action.id) ) return state;

      let newState = {...state};
      newState.items[action.id].selView = action.view;

      return newState;
    };
    default:
      return state
  }
}

//#endregion
